export type CountryOption = {
    value: string;
    label: string;
    code: string;
};

export const DEFAULT_LOCATION_COUNTRY = "United States";

/** ISO 3166-1 alpha-2 codes for https://react-circle-flags.pages.dev/{code}.svg */
export const COUNTRY_OPTIONS: CountryOption[] = [
    {
        value: "Afghanistan",
        label: "Afghanistan",
        code: "af"
    },
    {
        value: "Åland Islands",
        label: "Åland Islands",
        code: "ax"
    },
    {
        value: "Albania",
        label: "Albania",
        code: "al"
    },
    {
        value: "Algeria",
        label: "Algeria",
        code: "dz"
    },
    {
        value: "American Samoa",
        label: "American Samoa",
        code: "as"
    },
    {
        value: "Andorra",
        label: "Andorra",
        code: "ad"
    },
    {
        value: "Angola",
        label: "Angola",
        code: "ao"
    },
    {
        value: "Anguilla",
        label: "Anguilla",
        code: "ai"
    },
    {
        value: "Antarctica",
        label: "Antarctica",
        code: "aq"
    },
    {
        value: "Antigua & Barbuda",
        label: "Antigua & Barbuda",
        code: "ag"
    },
    {
        value: "Argentina",
        label: "Argentina",
        code: "ar"
    },
    {
        value: "Armenia",
        label: "Armenia",
        code: "am"
    },
    {
        value: "Aruba",
        label: "Aruba",
        code: "aw"
    },
    {
        value: "Australia",
        label: "Australia",
        code: "au"
    },
    {
        value: "Austria",
        label: "Austria",
        code: "at"
    },
    {
        value: "Azerbaijan",
        label: "Azerbaijan",
        code: "az"
    },
    {
        value: "Bahamas",
        label: "Bahamas",
        code: "bs"
    },
    {
        value: "Bahrain",
        label: "Bahrain",
        code: "bh"
    },
    {
        value: "Bangladesh",
        label: "Bangladesh",
        code: "bd"
    },
    {
        value: "Barbados",
        label: "Barbados",
        code: "bb"
    },
    {
        value: "Belarus",
        label: "Belarus",
        code: "by"
    },
    {
        value: "Belgium",
        label: "Belgium",
        code: "be"
    },
    {
        value: "Belize",
        label: "Belize",
        code: "bz"
    },
    {
        value: "Benin",
        label: "Benin",
        code: "bj"
    },
    {
        value: "Bermuda",
        label: "Bermuda",
        code: "bm"
    },
    {
        value: "Bhutan",
        label: "Bhutan",
        code: "bt"
    },
    {
        value: "Bolivia",
        label: "Bolivia",
        code: "bo"
    },
    {
        value: "Bosnia & Herzegovina",
        label: "Bosnia & Herzegovina",
        code: "ba"
    },
    {
        value: "Botswana",
        label: "Botswana",
        code: "bw"
    },
    {
        value: "Bouvet Island",
        label: "Bouvet Island",
        code: "bv"
    },
    {
        value: "Brazil",
        label: "Brazil",
        code: "br"
    },
    {
        value: "British Indian Ocean Territory",
        label: "British Indian Ocean Territory",
        code: "io"
    },
    {
        value: "British Virgin Islands",
        label: "British Virgin Islands",
        code: "vg"
    },
    {
        value: "Brunei",
        label: "Brunei",
        code: "bn"
    },
    {
        value: "Bulgaria",
        label: "Bulgaria",
        code: "bg"
    },
    {
        value: "Burkina Faso",
        label: "Burkina Faso",
        code: "bf"
    },
    {
        value: "Burundi",
        label: "Burundi",
        code: "bi"
    },
    {
        value: "Cambodia",
        label: "Cambodia",
        code: "kh"
    },
    {
        value: "Cameroon",
        label: "Cameroon",
        code: "cm"
    },
    {
        value: "Canada",
        label: "Canada",
        code: "ca"
    },
    {
        value: "Cape Verde",
        label: "Cape Verde",
        code: "cv"
    },
    {
        value: "Caribbean Netherlands",
        label: "Caribbean Netherlands",
        code: "bq"
    },
    {
        value: "Cayman Islands",
        label: "Cayman Islands",
        code: "ky"
    },
    {
        value: "Central African Republic",
        label: "Central African Republic",
        code: "cf"
    },
    {
        value: "Chad",
        label: "Chad",
        code: "td"
    },
    {
        value: "Chile",
        label: "Chile",
        code: "cl"
    },
    {
        value: "China",
        label: "China",
        code: "cn"
    },
    {
        value: "Christmas Island",
        label: "Christmas Island",
        code: "cx"
    },
    {
        value: "Cocos (Keeling) Islands",
        label: "Cocos (Keeling) Islands",
        code: "cc"
    },
    {
        value: "Colombia",
        label: "Colombia",
        code: "co"
    },
    {
        value: "Comoros",
        label: "Comoros",
        code: "km"
    },
    {
        value: "Congo - Brazzaville",
        label: "Congo - Brazzaville",
        code: "cg"
    },
    {
        value: "Congo - Kinshasa",
        label: "Congo - Kinshasa",
        code: "cd"
    },
    {
        value: "Cook Islands",
        label: "Cook Islands",
        code: "ck"
    },
    {
        value: "Costa Rica",
        label: "Costa Rica",
        code: "cr"
    },
    {
        value: "Côte d’Ivoire",
        label: "Côte d’Ivoire",
        code: "ci"
    },
    {
        value: "Croatia",
        label: "Croatia",
        code: "hr"
    },
    {
        value: "Cuba",
        label: "Cuba",
        code: "cu"
    },
    {
        value: "Curaçao",
        label: "Curaçao",
        code: "cw"
    },
    {
        value: "Cyprus",
        label: "Cyprus",
        code: "cy"
    },
    {
        value: "Czechia",
        label: "Czechia",
        code: "cz"
    },
    {
        value: "Denmark",
        label: "Denmark",
        code: "dk"
    },
    {
        value: "Djibouti",
        label: "Djibouti",
        code: "dj"
    },
    {
        value: "Dominica",
        label: "Dominica",
        code: "dm"
    },
    {
        value: "Dominican Republic",
        label: "Dominican Republic",
        code: "do"
    },
    {
        value: "Ecuador",
        label: "Ecuador",
        code: "ec"
    },
    {
        value: "Egypt",
        label: "Egypt",
        code: "eg"
    },
    {
        value: "El Salvador",
        label: "El Salvador",
        code: "sv"
    },
    {
        value: "Equatorial Guinea",
        label: "Equatorial Guinea",
        code: "gq"
    },
    {
        value: "Eritrea",
        label: "Eritrea",
        code: "er"
    },
    {
        value: "Estonia",
        label: "Estonia",
        code: "ee"
    },
    {
        value: "Eswatini",
        label: "Eswatini",
        code: "sz"
    },
    {
        value: "Ethiopia",
        label: "Ethiopia",
        code: "et"
    },
    {
        value: "Falkland Islands",
        label: "Falkland Islands",
        code: "fk"
    },
    {
        value: "Faroe Islands",
        label: "Faroe Islands",
        code: "fo"
    },
    {
        value: "Fiji",
        label: "Fiji",
        code: "fj"
    },
    {
        value: "Finland",
        label: "Finland",
        code: "fi"
    },
    {
        value: "France",
        label: "France",
        code: "fr"
    },
    {
        value: "French Guiana",
        label: "French Guiana",
        code: "gf"
    },
    {
        value: "French Polynesia",
        label: "French Polynesia",
        code: "pf"
    },
    {
        value: "French Southern Territories",
        label: "French Southern Territories",
        code: "tf"
    },
    {
        value: "Gabon",
        label: "Gabon",
        code: "ga"
    },
    {
        value: "Gambia",
        label: "Gambia",
        code: "gm"
    },
    {
        value: "Georgia",
        label: "Georgia",
        code: "ge"
    },
    {
        value: "Germany",
        label: "Germany",
        code: "de"
    },
    {
        value: "Ghana",
        label: "Ghana",
        code: "gh"
    },
    {
        value: "Gibraltar",
        label: "Gibraltar",
        code: "gi"
    },
    {
        value: "Greece",
        label: "Greece",
        code: "gr"
    },
    {
        value: "Greenland",
        label: "Greenland",
        code: "gl"
    },
    {
        value: "Grenada",
        label: "Grenada",
        code: "gd"
    },
    {
        value: "Guadeloupe",
        label: "Guadeloupe",
        code: "gp"
    },
    {
        value: "Guam",
        label: "Guam",
        code: "gu"
    },
    {
        value: "Guatemala",
        label: "Guatemala",
        code: "gt"
    },
    {
        value: "Guernsey",
        label: "Guernsey",
        code: "gg"
    },
    {
        value: "Guinea",
        label: "Guinea",
        code: "gn"
    },
    {
        value: "Guinea-Bissau",
        label: "Guinea-Bissau",
        code: "gw"
    },
    {
        value: "Guyana",
        label: "Guyana",
        code: "gy"
    },
    {
        value: "Haiti",
        label: "Haiti",
        code: "ht"
    },
    {
        value: "Heard & McDonald Islands",
        label: "Heard & McDonald Islands",
        code: "hm"
    },
    {
        value: "Honduras",
        label: "Honduras",
        code: "hn"
    },
    {
        value: "Hong Kong SAR China",
        label: "Hong Kong SAR China",
        code: "hk"
    },
    {
        value: "Hungary",
        label: "Hungary",
        code: "hu"
    },
    {
        value: "Iceland",
        label: "Iceland",
        code: "is"
    },
    {
        value: "India",
        label: "India",
        code: "in"
    },
    {
        value: "Indonesia",
        label: "Indonesia",
        code: "id"
    },
    {
        value: "Iran",
        label: "Iran",
        code: "ir"
    },
    {
        value: "Iraq",
        label: "Iraq",
        code: "iq"
    },
    {
        value: "Ireland",
        label: "Ireland",
        code: "ie"
    },
    {
        value: "Isle of Man",
        label: "Isle of Man",
        code: "im"
    },
    {
        value: "Israel",
        label: "Israel",
        code: "il"
    },
    {
        value: "Italy",
        label: "Italy",
        code: "it"
    },
    {
        value: "Jamaica",
        label: "Jamaica",
        code: "jm"
    },
    {
        value: "Japan",
        label: "Japan",
        code: "jp"
    },
    {
        value: "Jersey",
        label: "Jersey",
        code: "je"
    },
    {
        value: "Jordan",
        label: "Jordan",
        code: "jo"
    },
    {
        value: "Kazakhstan",
        label: "Kazakhstan",
        code: "kz"
    },
    {
        value: "Kenya",
        label: "Kenya",
        code: "ke"
    },
    {
        value: "Kiribati",
        label: "Kiribati",
        code: "ki"
    },
    {
        value: "Kuwait",
        label: "Kuwait",
        code: "kw"
    },
    {
        value: "Kyrgyzstan",
        label: "Kyrgyzstan",
        code: "kg"
    },
    {
        value: "Laos",
        label: "Laos",
        code: "la"
    },
    {
        value: "Latvia",
        label: "Latvia",
        code: "lv"
    },
    {
        value: "Lebanon",
        label: "Lebanon",
        code: "lb"
    },
    {
        value: "Lesotho",
        label: "Lesotho",
        code: "ls"
    },
    {
        value: "Liberia",
        label: "Liberia",
        code: "lr"
    },
    {
        value: "Libya",
        label: "Libya",
        code: "ly"
    },
    {
        value: "Liechtenstein",
        label: "Liechtenstein",
        code: "li"
    },
    {
        value: "Lithuania",
        label: "Lithuania",
        code: "lt"
    },
    {
        value: "Luxembourg",
        label: "Luxembourg",
        code: "lu"
    },
    {
        value: "Macao SAR China",
        label: "Macao SAR China",
        code: "mo"
    },
    {
        value: "Madagascar",
        label: "Madagascar",
        code: "mg"
    },
    {
        value: "Malawi",
        label: "Malawi",
        code: "mw"
    },
    {
        value: "Malaysia",
        label: "Malaysia",
        code: "my"
    },
    {
        value: "Maldives",
        label: "Maldives",
        code: "mv"
    },
    {
        value: "Mali",
        label: "Mali",
        code: "ml"
    },
    {
        value: "Malta",
        label: "Malta",
        code: "mt"
    },
    {
        value: "Marshall Islands",
        label: "Marshall Islands",
        code: "mh"
    },
    {
        value: "Martinique",
        label: "Martinique",
        code: "mq"
    },
    {
        value: "Mauritania",
        label: "Mauritania",
        code: "mr"
    },
    {
        value: "Mauritius",
        label: "Mauritius",
        code: "mu"
    },
    {
        value: "Mayotte",
        label: "Mayotte",
        code: "yt"
    },
    {
        value: "Mexico",
        label: "Mexico",
        code: "mx"
    },
    {
        value: "Micronesia",
        label: "Micronesia",
        code: "fm"
    },
    {
        value: "Moldova",
        label: "Moldova",
        code: "md"
    },
    {
        value: "Monaco",
        label: "Monaco",
        code: "mc"
    },
    {
        value: "Mongolia",
        label: "Mongolia",
        code: "mn"
    },
    {
        value: "Montenegro",
        label: "Montenegro",
        code: "me"
    },
    {
        value: "Montserrat",
        label: "Montserrat",
        code: "ms"
    },
    {
        value: "Morocco",
        label: "Morocco",
        code: "ma"
    },
    {
        value: "Mozambique",
        label: "Mozambique",
        code: "mz"
    },
    {
        value: "Myanmar (Burma)",
        label: "Myanmar (Burma)",
        code: "mm"
    },
    {
        value: "Namibia",
        label: "Namibia",
        code: "na"
    },
    {
        value: "Nauru",
        label: "Nauru",
        code: "nr"
    },
    {
        value: "Nepal",
        label: "Nepal",
        code: "np"
    },
    {
        value: "Netherlands",
        label: "Netherlands",
        code: "nl"
    },
    {
        value: "New Caledonia",
        label: "New Caledonia",
        code: "nc"
    },
    {
        value: "New Zealand",
        label: "New Zealand",
        code: "nz"
    },
    {
        value: "Nicaragua",
        label: "Nicaragua",
        code: "ni"
    },
    {
        value: "Niger",
        label: "Niger",
        code: "ne"
    },
    {
        value: "Nigeria",
        label: "Nigeria",
        code: "ng"
    },
    {
        value: "Niue",
        label: "Niue",
        code: "nu"
    },
    {
        value: "Norfolk Island",
        label: "Norfolk Island",
        code: "nf"
    },
    {
        value: "North Korea",
        label: "North Korea",
        code: "kp"
    },
    {
        value: "North Macedonia",
        label: "North Macedonia",
        code: "mk"
    },
    {
        value: "Northern Mariana Islands",
        label: "Northern Mariana Islands",
        code: "mp"
    },
    {
        value: "Norway",
        label: "Norway",
        code: "no"
    },
    {
        value: "Oman",
        label: "Oman",
        code: "om"
    },
    {
        value: "Pakistan",
        label: "Pakistan",
        code: "pk"
    },
    {
        value: "Palau",
        label: "Palau",
        code: "pw"
    },
    {
        value: "Palestinian Territories",
        label: "Palestinian Territories",
        code: "ps"
    },
    {
        value: "Panama",
        label: "Panama",
        code: "pa"
    },
    {
        value: "Papua New Guinea",
        label: "Papua New Guinea",
        code: "pg"
    },
    {
        value: "Paraguay",
        label: "Paraguay",
        code: "py"
    },
    {
        value: "Peru",
        label: "Peru",
        code: "pe"
    },
    {
        value: "Philippines",
        label: "Philippines",
        code: "ph"
    },
    {
        value: "Pitcairn Islands",
        label: "Pitcairn Islands",
        code: "pn"
    },
    {
        value: "Poland",
        label: "Poland",
        code: "pl"
    },
    {
        value: "Portugal",
        label: "Portugal",
        code: "pt"
    },
    {
        value: "Puerto Rico",
        label: "Puerto Rico",
        code: "pr"
    },
    {
        value: "Qatar",
        label: "Qatar",
        code: "qa"
    },
    {
        value: "Réunion",
        label: "Réunion",
        code: "re"
    },
    {
        value: "Romania",
        label: "Romania",
        code: "ro"
    },
    {
        value: "Russia",
        label: "Russia",
        code: "ru"
    },
    {
        value: "Rwanda",
        label: "Rwanda",
        code: "rw"
    },
    {
        value: "Samoa",
        label: "Samoa",
        code: "ws"
    },
    {
        value: "San Marino",
        label: "San Marino",
        code: "sm"
    },
    {
        value: "São Tomé & Príncipe",
        label: "São Tomé & Príncipe",
        code: "st"
    },
    {
        value: "Saudi Arabia",
        label: "Saudi Arabia",
        code: "sa"
    },
    {
        value: "Senegal",
        label: "Senegal",
        code: "sn"
    },
    {
        value: "Serbia",
        label: "Serbia",
        code: "rs"
    },
    {
        value: "Seychelles",
        label: "Seychelles",
        code: "sc"
    },
    {
        value: "Sierra Leone",
        label: "Sierra Leone",
        code: "sl"
    },
    {
        value: "Singapore",
        label: "Singapore",
        code: "sg"
    },
    {
        value: "Sint Maarten",
        label: "Sint Maarten",
        code: "sx"
    },
    {
        value: "Slovakia",
        label: "Slovakia",
        code: "sk"
    },
    {
        value: "Slovenia",
        label: "Slovenia",
        code: "si"
    },
    {
        value: "Solomon Islands",
        label: "Solomon Islands",
        code: "sb"
    },
    {
        value: "Somalia",
        label: "Somalia",
        code: "so"
    },
    {
        value: "South Africa",
        label: "South Africa",
        code: "za"
    },
    {
        value: "South Georgia & South Sandwich Islands",
        label: "South Georgia & South Sandwich Islands",
        code: "gs"
    },
    {
        value: "South Korea",
        label: "South Korea",
        code: "kr"
    },
    {
        value: "South Sudan",
        label: "South Sudan",
        code: "ss"
    },
    {
        value: "Spain",
        label: "Spain",
        code: "es"
    },
    {
        value: "Sri Lanka",
        label: "Sri Lanka",
        code: "lk"
    },
    {
        value: "St. Barthélemy",
        label: "St. Barthélemy",
        code: "bl"
    },
    {
        value: "St. Helena",
        label: "St. Helena",
        code: "sh"
    },
    {
        value: "St. Kitts & Nevis",
        label: "St. Kitts & Nevis",
        code: "kn"
    },
    {
        value: "St. Lucia",
        label: "St. Lucia",
        code: "lc"
    },
    {
        value: "St. Martin",
        label: "St. Martin",
        code: "mf"
    },
    {
        value: "St. Pierre & Miquelon",
        label: "St. Pierre & Miquelon",
        code: "pm"
    },
    {
        value: "St. Vincent & Grenadines",
        label: "St. Vincent & Grenadines",
        code: "vc"
    },
    {
        value: "Sudan",
        label: "Sudan",
        code: "sd"
    },
    {
        value: "Suriname",
        label: "Suriname",
        code: "sr"
    },
    {
        value: "Svalbard & Jan Mayen",
        label: "Svalbard & Jan Mayen",
        code: "sj"
    },
    {
        value: "Sweden",
        label: "Sweden",
        code: "se"
    },
    {
        value: "Switzerland",
        label: "Switzerland",
        code: "ch"
    },
    {
        value: "Syria",
        label: "Syria",
        code: "sy"
    },
    {
        value: "Taiwan",
        label: "Taiwan",
        code: "tw"
    },
    {
        value: "Tajikistan",
        label: "Tajikistan",
        code: "tj"
    },
    {
        value: "Tanzania",
        label: "Tanzania",
        code: "tz"
    },
    {
        value: "Thailand",
        label: "Thailand",
        code: "th"
    },
    {
        value: "Timor-Leste",
        label: "Timor-Leste",
        code: "tl"
    },
    {
        value: "Togo",
        label: "Togo",
        code: "tg"
    },
    {
        value: "Tokelau",
        label: "Tokelau",
        code: "tk"
    },
    {
        value: "Tonga",
        label: "Tonga",
        code: "to"
    },
    {
        value: "Trinidad & Tobago",
        label: "Trinidad & Tobago",
        code: "tt"
    },
    {
        value: "Tunisia",
        label: "Tunisia",
        code: "tn"
    },
    {
        value: "Türkiye",
        label: "Türkiye",
        code: "tr"
    },
    {
        value: "Turkmenistan",
        label: "Turkmenistan",
        code: "tm"
    },
    {
        value: "Turks & Caicos Islands",
        label: "Turks & Caicos Islands",
        code: "tc"
    },
    {
        value: "Tuvalu",
        label: "Tuvalu",
        code: "tv"
    },
    {
        value: "U.S. Outlying Islands",
        label: "U.S. Outlying Islands",
        code: "um"
    },
    {
        value: "U.S. Virgin Islands",
        label: "U.S. Virgin Islands",
        code: "vi"
    },
    {
        value: "Uganda",
        label: "Uganda",
        code: "ug"
    },
    {
        value: "Ukraine",
        label: "Ukraine",
        code: "ua"
    },
    {
        value: "United Arab Emirates",
        label: "United Arab Emirates",
        code: "ae"
    },
    {
        value: "United Kingdom",
        label: "United Kingdom",
        code: "gb"
    },
    {
        value: "United States",
        label: "United States",
        code: "us"
    },
    {
        value: "Uruguay",
        label: "Uruguay",
        code: "uy"
    },
    {
        value: "Uzbekistan",
        label: "Uzbekistan",
        code: "uz"
    },
    {
        value: "Vanuatu",
        label: "Vanuatu",
        code: "vu"
    },
    {
        value: "Vatican City",
        label: "Vatican City",
        code: "va"
    },
    {
        value: "Venezuela",
        label: "Venezuela",
        code: "ve"
    },
    {
        value: "Vietnam",
        label: "Vietnam",
        code: "vn"
    },
    {
        value: "Wallis & Futuna",
        label: "Wallis & Futuna",
        code: "wf"
    },
    {
        value: "Western Sahara",
        label: "Western Sahara",
        code: "eh"
    },
    {
        value: "Yemen",
        label: "Yemen",
        code: "ye"
    },
    {
        value: "Zambia",
        label: "Zambia",
        code: "zm"
    },
    {
        value: "Zimbabwe",
        label: "Zimbabwe",
        code: "zw"
    }
];

export function circleFlagUrl(code: string): string {
    return `https://react-circle-flags.pages.dev/${code.toLowerCase()}.svg`;
}

export function countryMeta(value: string): CountryOption | undefined {
    return COUNTRY_OPTIONS.find((option) => option.value.toLowerCase() === value.toLowerCase());
}

/** Resolve ISO 3166-1 alpha-2 from a country display name or 2-letter code. */
export function countryIsoCodeFromValue(value: string): string {
    const trimmed = (value || "").trim();
    if (!trimmed) return "";
    const byName = countryMeta(trimmed);
    if (byName) return byName.code.toUpperCase();
    const byCode = COUNTRY_OPTIONS.find((option) => option.code.toLowerCase() === trimmed.toLowerCase());
    if (byCode) return byCode.code.toUpperCase();
    if (trimmed.length === 2) return trimmed.toUpperCase();
    return "";
}
